import { AUTH_ERROR_CODES, type AuthErrorCode, OAuthProvider, type OAuthProvider as OAuthProviderType } from "@upsquad/shared";
import { useTranslation } from "react-i18next";
import { Alert, Button } from "@/src/common/components/ui";

interface AuthMethodErrorProps {
	error: AuthErrorCode;
	provider?: OAuthProviderType;
	onDismiss: () => void;
}

export function AuthMethodError({ error, provider, onDismiss }: AuthMethodErrorProps) {
	const { t } = useTranslation("auth");

	const isOAuthError = error === AUTH_ERROR_CODES.OAUTH_ACCOUNT;
	const isMicrosoft = provider === OAuthProvider.MICROSOFT;

	const message = isOAuthError
		? isMicrosoft
			? t("oauth_error_message_microsoft")
			: t("oauth_error_message_google")
		: t("email_error_message");
	const ctaLabel = isOAuthError ? (isMicrosoft ? t("use_microsoft") : t("use_google")) : t("use_email");

	return (
		<Alert status="danger">
			<Alert.Content>
				<Alert.Title>{t("oauth_error_title")}</Alert.Title>
				<Alert.Description>
					<p className="mb-3">{message}</p>
					<Button size="sm" variant="ghost" onPress={onDismiss}>
						{ctaLabel}
					</Button>
				</Alert.Description>
			</Alert.Content>
		</Alert>
	);
}
